<template>
    <v-expand-transition>
        <v-card v-show="show" class="elevation-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
            <v-card-text class="py-0">
                <v-row class="mt-6">
                    <v-col cols="12" sm="4" class="py-0">
                        <v-select v-model="filter.isWhole" :items="categories" item-text="text" item-value="value" dense hide-details label="구분" placeholder=" " @change="search()" />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0">
                        <v-select v-model="filter.searchKey" label="검색조건" placeholder=" " :items="searchKeys" dense hide-details />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0">
                        <v-text-field v-model="filter.searchValue" dense hide-details type="text" label="검색어" placeholder=" " @keydown="(e) => e.keyCode === 13 && search()" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
            </v-card-actions>
        </v-card>
    </v-expand-transition>
</template>

<script>
export default {
    props: {
        value: {
            isWhole: { type: Boolean, default: undefined },
            searchKey: { type: String, default: undefined },
            searchValue: { type: String, default: undefined },
        },
    },
    data() {
        return {
            show: true,
            filter: {
                isWhole: undefined,
                searchKey: undefined,
                searchValue: undefined,
            },

            categories: [
                { text: "전체", value: null },
                { text: "종합", value: true },
                { text: "부분", value: false },
            ],
            searchKeys: [
                { text: "전체", value: "all" },
                { text: "계약번호", value: "contractNumber" },
                // { text: "계약담당자", value: "measurer.name" },
                // { text: "업체명", value: "latestDocument.employer.businessName" },
                { text: "고객명", value: "meta.employer.name" },
                { text: "고객연락처", value: "meta.employer.phone" },
                // { text: "가상계좌", value: "paymentBankAccount.number" },
            ],
        };
    },
    mounted() {
        this.filter = Object.assignDefined(this.filter, this.value);
    },
    methods: {
        search() {
            this.$emit("input", JSON.parse(JSON.stringify(this.filter)));
        },
    },
    watch: {
        value() {
            this.filter = Object.assignDefined(this.filter, this.value);
        },
    },
};
</script>

<style></style>
